/**************************************************
 * Nombre:       Casilla_Avatar_Titulo_Dato
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {TableCell, Typography} from "@mui/material";
import {COLORTEXTO} from "../../../Constantes";
import {Grid} from "@mui/system";

const Casilla_Parrafo = ({dato, dir, lineas = 2}) => {

    return (
        <TableCell key={dato} variant={'body'} align={dir}
        >

            <Typography sx={{
                color: COLORTEXTO, fontSize: 14, fontWeight: 500,
                textOverflow: "ellipsis",
                display: '-webkit-box',
                overflow: 'hidden',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: lineas
            }}>
                {dato}
            </Typography>

        </TableCell>

    )

}
export default Casilla_Parrafo